var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Btn',{staticClass:"BtnCopy ib xs",attrs:{"alt":"Kopijuoti"},on:{"click":function($event){return _vm.copy(_vm.text)}}},[_c('Icon',{attrs:{"name":"file"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }